module.exports = __webpack_public_path__ + "img/teledolar.5bfb8d1.png";